export const SEGMENT_ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id';
export const CONSENT_COOKIE_NAME = 'eop-tracking-preferences';
export const DISABLE_CONSENT_MANAGER_COOKIE = 'disable-segment';
